import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { ProjectService } from '../../../../data/project/project.service';
import { ProjectComment } from '../../../../data/project/project-comment';
import { Project } from '../../../../data/project/project';
import { TrelloCheckItem } from 'projects/app-misc/src/app/modules/trello-misc/data/trello-check-item';
import { ProjectHolder } from '../../../../interfaces/project-holder';
import { User } from 'projects/core/src/lib/login/data/user';
import { Subscription, timer } from 'rxjs';

@Component({
    selector: 'app-edit-comment',
    templateUrl: './edit-comment.component.html',
    styleUrls: ['./edit-comment.component.scss']
})
export class EditCommentComponent implements OnInit, AfterViewInit {
    @Input()
    comment: ProjectComment;

    project: Project

    @Input()
    users: User[];

    itemDescription: string;

    @Output() closeAction = new EventEmitter<void>();
    @Output() updateAction = new EventEmitter<ProjectComment>();
    @Output() deleteAction = new EventEmitter<ProjectComment>();

    @ViewChild('punchItemTextArea', { static: true })
    punchItemTextArea: ElementRef;

    loadingSpinner = false;
    deleteLoadingSpinner = false;

    ctrlEventListener = null;
    tempKey: any;
    timerSub: Subscription;

    constructor(
        protected projectHolder: ProjectHolder,
        protected projectService: ProjectService,
    ) {
        this.project = this.projectHolder.project
    }

    ngOnInit() {
        this.itemDescription = this.comment.text;
        this.subToCTRLEnter();
    }

    subToCTRLEnter() {
        this.ctrlEventListener = (event: KeyboardEvent) => {
            this.ctrlEnterEvent(event)
        }

        document.addEventListener('keydown', this.ctrlEventListener);
    }

    ctrlEnterEvent(event) {
        const key = (event as KeyboardEvent).key; // const {key} = event; in ES6+

        if (this.tempKey === 'Control') {
            if (key === 'Enter') {
                this.saveComment();
            }
        }
        this.tempKey = key;

        if (!this.timerSub) {
            this.timerSub = timer(500).subscribe(eimt => {
                this.tempKey = null;
                this.timerSub = null;
            })
        }
    }

    ngAfterViewInit() {
        (this.punchItemTextArea.nativeElement as HTMLElement).focus();
    }

    saveComment() {
        this.loadingSpinner = true;

        const commentData: ProjectComment = {
            id: null,
            text: this.itemDescription
        }

        this.projectService.saveComment(this.project.id, this.comment.id, commentData).subscribe(comment => {
            this.updateAction.emit(comment);
            this.loadingSpinner = false;
        }, error => {
            this.loadingSpinner = false;
        })

    }


    hideInputItem() {
        this.closeAction.emit();
    }

    deleteItem() {
        this.deleteLoadingSpinner = true;
        this.deleteAction.emit();
    }

    onMentionSelect(user: User) {
        return '@' + user.username + ' ';
    }
}